import { useParams } from 'react-router-dom';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Divider } from 'antd';
import { showErrorToast } from '../../../../services/notificationsService';
import { useGetTitleEntityDetails } from '../../../../queries/TitleEntity';
import { getDefaultRangePickerValue } from '../../../../utils';
import { ViewPanel } from '../../../../containers/view/ViewPanel';
import { ZorbaDateRangePicker } from '../../../../components/forms/ZorbaDateRangePicker';
import { AccountTabs } from './Components/AccountTabs';
import { Header } from './Components/Header';
import { Overview } from './Components/Overview';
import { Transactions } from './Components/Transactions';
import { Clients } from './Components/Clients';
import { getTitleFromSlug } from './constants';

import './index.scss';

export const TitleEntity = () => {
  const { titleCompanyName } = useParams();
  const formattedTitleCompanyName = getTitleFromSlug(titleCompanyName);

  const [activeTab, setActiveTab] = useState('1');
  const [selectedRange, setSelectedRange] = useState(
    getDefaultRangePickerValue(90),
  );
  const { appliedFilters } = useSelector(
    ({ FiltersReducer }) => FiltersReducer,
  );

  const {
    data: titleCompanyData,
    isLoading,
    isError,
  } = useGetTitleEntityDetails({
    selectedRange,
    titleCompanyName: formattedTitleCompanyName,
    appliedFilters,
  });

  if (isError) {
    showErrorToast('Fetching title company details failed!');
  }

  const isMultiFamilySelected = appliedFilters?.propertyType?.isAnyOf?.includes(
    'Multi Family Home',
  );
  const isVacantSelected = appliedFilters?.propertyType?.isAnyOf?.includes(
    'Vacant',
  );

  const renderComponent = () => {
    switch (activeTab) {
      case '1':
        return (
          <Overview
            titleCompanyName={formattedTitleCompanyName}
            appliedFilters={appliedFilters}
            selectedRange={selectedRange}
            titleCompanyData={titleCompanyData}
            isDataLoading={isLoading}
          />
        );
      case '2':
        return (
          <Clients
            titleCompanyName={formattedTitleCompanyName}
            appliedFilters={appliedFilters}
            selectedRange={selectedRange}
          />
        );
      case '3':
        return (
          <Transactions
            isMultiFamilySelected={isMultiFamilySelected}
            isVacantSelected={isVacantSelected}
            appliedFilters={appliedFilters}
            selectedRange={selectedRange}
            titleCompanyName={formattedTitleCompanyName}
          />
        );

      default:
        return <div />;
    }
  };

  return (
    <div className="title-company-page">
      <div className="account-details-filter">
        <Header titleCompanyName={formattedTitleCompanyName} />
        <AccountTabs setActiveTab={setActiveTab} activeTab={activeTab} />
      </div>
      <Divider className="divider" />
      {(activeTab === '1' || activeTab === '2' || activeTab === '3') && (
        <ViewPanel availableFilters={['propertyType', 'state']}>
          <ZorbaDateRangePicker
            onChange={(e) => setSelectedRange(e)}
            value={selectedRange}
            rangePresets={[
              { label: 'Last 30 days', value: 30 },
              { label: 'Last 60 days', value: 60 },
              { label: 'Last 90 days', value: 90 },
            ]}
            disabled={isLoading}
          />
        </ViewPanel>
      )}
      {renderComponent()}
    </div>
  );
};
